import { createSlice } from "@reduxjs/toolkit";


const SearchSlice = createSlice({
    name: 'search',
    initialState: "",
    reducers: {
        setSearchKey(state, action) {
            return action.payload;
        }
    }
})

export const { setSearchKey } = SearchSlice.actions;
export default SearchSlice.reducer;